import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { authService } from '../api/authService'

export default function RequireAuth({ children }) {
  const location = useLocation()
  const isAuth = authService.isAuthenticated()
  
  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }
  
  return children
}
